import { Divider } from "antd";
import type React from "react";
import { MemberBlockStatusFilter } from "../components/filters/MemberBlockStatusFilter";

import { MemberChatStatusFilter } from "../components/filters/MemberChatStatusFilter";
import { MemberFriendAddDateRangeFilter } from "../components/filters/MemberFriendAddDateRangeFilter";
import { MemberLastVisitDateRangeFilter } from "../components/filters/MemberLastVisitDateRangeFilter";
import { MemberMembershipStatusFilter } from "../components/filters/MemberMembershipStatusFilter";
import { MemberPaymentCompletedAtFilter } from "../components/filters/MemberPaymentCompletedAtFilter";
import { MemberPaymentMethodFilter } from "../components/filters/MemberPaymentMethodFilter";
import { MemberRegistrationStatusFilter } from "../components/filters/MemberRegistrationStatusFilter";
import { MemberSinceDateRangeFilter } from "../components/filters/MemberSinceDateRangeFilter";

type MemberAudienceFiltersProps = {};

export const MemberAudienceFilters: React.FC<
	MemberAudienceFiltersProps
> = () => {
	return (
		<>
			<Divider>会員登録状態で検索</Divider>
			<MemberRegistrationStatusFilter />

			<Divider>会員ステータスで検索</Divider>
			<MemberMembershipStatusFilter />

			<Divider>ブロック状態で検索</Divider>
			<MemberBlockStatusFilter />

			<Divider>LINEチャットで検索</Divider>
			<MemberChatStatusFilter />

			<Divider>友だち追加日で検索</Divider>
			<MemberFriendAddDateRangeFilter />

			<Divider>会員登録日で検索</Divider>
			<MemberSinceDateRangeFilter />

			<Divider>最終来館日で検索</Divider>
			<MemberLastVisitDateRangeFilter />

			<Divider>決済方法で検索</Divider>
			<MemberPaymentMethodFilter />

			<Divider>決済完了日で検索</Divider>
			<MemberPaymentCompletedAtFilter />
		</>
	);
};
